import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 20px;
`;

export const InputsWrap = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
  span {
    display: flex;
    gap: 12px;
    align-items: center;
    a {
      display: flex;
      gap: 12px;
      color: "#007bff";
    }
  }
`;
